import { useState } from "react";

import {
  PriceInfoContainer,
  PriceInfoButton,
  InfoBubble,
  InfoBubbleText,
} from "./styles";

import {ReactComponent as InfoCircle} from './infoCircle.svg' 

const PriceInfo = ({ thirtyDayLowestInfo, priceInfo }) => {
  const [showInfoBubble, setShowInfoBubble] = useState(false);

  return (
    <PriceInfoContainer
      onMouseEnter={() => setShowInfoBubble(true)}
      onMouseLeave={() => setShowInfoBubble(false)}
    >
      {showInfoBubble && (
        <InfoBubble>
          <InfoBubbleText>{thirtyDayLowestInfo}</InfoBubbleText>
        </InfoBubble>
      )}

      <PriceInfoButton
        onClick={() =>
          showInfoBubble ? setShowInfoBubble(true) : setShowInfoBubble(false)
        }
      >
        <InfoCircle />
        
        <span>{priceInfo}</span>
      </PriceInfoButton>
    </PriceInfoContainer>
  );
};

export default PriceInfo;
